module.exports = __webpack_public_path__ + "static/media/so.7065065c.svg";